import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { ModalController } from '@ionic/angular';

import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'send-photos-ai',
  templateUrl: './send-photos-ai.component.html',
  styleUrls: [
    './send-photos-ai.component.scss'
  ]
})
export class SendPhotosAiComponent implements OnInit {

  photos: any[] = [];
  photoPlaceholder: string | null = null;

  spin: number = 0;

  error: boolean = false;
  errorData: any = null;
  errorMessage: string | null = null;

  constructor(
    private modalController: ModalController,
    private translate: TranslateService,
  ) { }

  ngOnInit() {}

  dismiss(data?: any) {
    this.modalController.dismiss(data, 'cancel');
  }

  onProcessed(event: any) {
    console.log('onAIResult', event);
    this.spin++;
    if (this.isDone()) {
      setTimeout(() => {
        this.modalController.dismiss(null, 'processed');
      }, 1000);
    }
  }

  onError(data?: any) {
    this.spin++;
    this.error = true;
    this.errorData = data;
    this.errorMessage = data.error.error.message;
    // this.modalController.dismiss(data, 'processed');
  }

  isDone() {
    return this.photos.length <= this.spin;
  }
}
